import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyFieldConfig, FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from './auth.service';
import { EMPTY, catchError, tap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'oc-forgotten-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormlyBootstrapModule, FormlyModule, RouterModule],
  template: `
    <div class="fullscreen-container primary-background d-flex">
      <div class="background background-1"></div>
      <div class="pane d-flex flex-column justify-content-center">
        <div class="pane-padding">
          <h1>Forgotten Password</h1>
          <form [formGroup]="form" (ngSubmit)="onSubmit(model)">
            <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
            <button type="submit" class="btn btn-primary w-100 mt-3 mb-3">
              <span *ngIf="loggingIn" class="spinner-border spinner-border-sm"></span>
              <span *ngIf="!loggingIn">Submit</span>
            </button>

            <button [routerLink]="['/login']" type="button" class="btn btn-secondary w-100 mb-4">Cancel</button>
          </form>
        </div>
      </div>
    </div>
  `,
  styles: `
    h1 {
      margin-bottom: 1.75rem;
    }
    
  `,
})
export class ForgottenPasswordComponent {
  private auth = inject(AuthService);
  private router = inject(Router);
  private toastr = inject(ToastrService);

  loggingIn = false;
  form = new FormGroup({});
  model = { email: '' };

  options: FormlyFormOptions = {
    formState: {
      submitted: false,
    },
  };

  fields: FormlyFieldConfig[] = [
    {
      key: 'email',
      type: 'input',
      props: {
        label: 'Email',
        required: true,
        type: 'email',
        hideRequiredMarker: true,
      },
      validators: {
        validation: ['email'],
      },
    },
  ];

  onSubmit(model: any) {
    this.options.formState.submitted = true;

    if (this.loggingIn) {
      return;
    }

    if (!this.form.valid) {
      this.toastr.error('Please review your login details and try again');
      return;
    }

    this.loggingIn = true;

    this.auth
      .forgottenPassword(model.email)
      .pipe(
        catchError((err) => {
          this.toastr.error(err.message);
          this.loggingIn = false;
          return EMPTY;
        }),
        tap(() => {
          this.router.navigate(['/']);
        }),
      )
      .subscribe();
  }
}
